"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SourceCreateController", {
    enumerable: true,
    get: function() {
        return SourceCreateController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _catchError = require("~/helpers/catchError");
const _Jobs = require("~/interface/Jobs");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let SourceCreateController = class SourceCreateController {
    async baseCreate(context, baseId, body, req) {
        const jobs = await this.jobsService.jobList();
        const fnd = jobs.find((j)=>j.name === _Jobs.JobTypes.SourceCreate && j.data.baseId === baseId);
        if (fnd) {
            _catchError.NcError.badRequest('Another source creation is in progress for this base.');
        }
        const job = await this.jobsService.add(_Jobs.JobTypes.SourceCreate, {
            context,
            user: req.user,
            baseId,
            source: body,
            req
        });
        return {
            id: job.id
        };
    }
    constructor(jobsService){
        this.jobsService = jobsService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/bases',
        '/api/v2/meta/bases/:baseId/sources'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('sourceCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.BaseReqType === "undefined" ? Object : _nocodbsdk.BaseReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SourceCreateController.prototype, "baseCreate", null);
SourceCreateController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService
    ])
], SourceCreateController);
